import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	copyLink: {
		id: 'software-copy-to-clipboard.copy-link',
		defaultMessage: 'Copy issue link',
		description: 'Copy message to display in dropdown item',
	},
	copySuccessTitle: {
		id: 'software-copy-to-clipboard.copy-success-title',
		defaultMessage: 'Issue link copied',
		description: 'Flag title for successful copy',
	},
	copySuccessMessage: {
		id: 'software-copy-to-clipboard.copy-success-message',
		defaultMessage: 'Issue link successfully copied to your clipboard',
		description: 'Flag message for successful copy',
	},
});
